import axios from 'axios'

export const AXIOS = axios.create({ baseURL: '/' })

export const UPLOAD_CONFIG = {
  fileParallelism: 4, // для мобильного интерфейса изменяется на 1. Используется 4, потому что 2 из 6 параллельных запросов браузера отдаются на периодическое получение событий и других данных
  resizableImageExtensions: new Set(['.png', '.gif', '.jpg', '.jpeg', '.bmp', '.tif', '.tiff', '.webp']),
  imageExtensionsToConvert: new Set(['.webp']),
  prohibitedImageExtensions: new Set(['.heic', '.heif', '.dng']),
  allowedVideoExtensions: new Set(['.mp4', '.webm', '.ogv', '.avi', '.mov', '.m4v']),
  maxImageWidth: 1024,
  maxImageHeight: 1024,
  maxFileSize: 4 * 1024 * 1024 * 1024 // 4GB in bytes
}

AXIOS.interceptors.request.use(
  function (config) {
    if (config.url.includes('/upload')) {
      if (!config.headers) {
        config.headers = {}
      }
      config.headers['Client-Upload-Request-Id'] = Date.now() - Math.random()
      if (!config.headers['Execute-In-Main']) {
        config.timeout = config.timeout || 5 * 60000 // 5 минут
      }
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

AXIOS.interceptors.response.use(
  function (response) {
    const url = response.request.responseURL

    const index = url.indexOf('/login')
    if (index !== -1) {
      console.log('Redirect to: ' + url.substring(index))
      window.location.replace(url)
    }

    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

function getOriginResolveFn (resolve, reject) {
  return (response) => {
    if (response && response.data && response.data.message === 'server_unavailable') {
      if (this && response.config.url !== '/service/delta/user/current') {
        this.$router.push({ name: 'error503' })
        response.data.message = 'Сервер временно недоступен!'
      }
    }
    if (response.data.status && response.data.status == 'error') {
      if (reject) {
        response.data.status = -1
        reject(response.data)
      }
    } else if (resolve) {
      resolve(response)
    }
  }
}

function getOriginRejectFn (reject) {
  return function (error) {
    let data = error.response ? error.response.data : null

    if (data && data.status === 'error') {
      data.status = error.response.status
    } else {
      const responseStatus = error.response ? error.response.status : null
      let timeoutError
      if (responseStatus != null) {
        timeoutError = responseStatus === 408 || responseStatus === 504
      } else {
        timeoutError = !!error.message && error.message.includes('timeout')
      }

      if (typeof data === 'string') {
        data = {
          message: data,
          status: -2,
          code: timeoutError ? 'timeout' : null,
          notify: false
        }
      } else if (!data) {
        data = {
          message: timeoutError ? 'Превышено время выполнения запроса' : error.message,
          status: -2,
          code: timeoutError ? 'timeout' : null,
          notify: error.message.includes('Network Error') || timeoutError
        }
        // Отправляем Service Worker команду на прерывание запроса, чтобы загрузка файла не продолжалась в фоновом режиме.
        if (error.config.headers['Client-Upload-Request-Id'] && navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({
            type: 'REQUEST_ABORT',
            requestId: error.config.headers['Client-Upload-Request-Id']
          })
        }
      }
    }

    data._error = error

    reject(data)
  }
}

export function axiosGet (conf) {
  const promise = AXIOS.get(conf.url)
  return axiosRequest(promise, conf)
}

export function axiosDelete (conf) {
  const promise = AXIOS({
    method: 'delete',
    url: conf.url,
    data: conf.data,
    config: conf.config
  })
  return axiosRequest(promise, conf)
}

export function axiosPost (conf) {
  const promise = AXIOS.post(conf.url, conf.data, conf.config)
  return axiosRequest(promise, conf)
}

export function axiosRequest (originPromise, conf) {
  let onFailure = null
  if (conf.onFailure != null) {
    if (typeof conf.onFailure === 'function') {
      onFailure = conf.onFailure
    } else if (typeof conf.onFailure === 'string' || conf.onFailure === true) {
      if (!conf.msgTarget) {
        const contentAreas = document.getElementsByClassName('content_display_area')
        if (contentAreas.length) {
          conf.msgTarget = contentAreas[0].__vue__ || null
        }
      }
      if (conf.msgTarget) {
        const msg = typeof conf.onFailure === 'string' ? conf.onFailure : 'Ошибка'
        onFailure = function (error) {
          noticeError.call(conf.msgTarget, error, msg)
          if (conf.throws) {
            throw error
          }
        }
      }
    }
  }

  let promise = new Promise((resolve, reject) => {
    originPromise
      .then(getOriginResolveFn.call(conf.msgTarget, resolve, reject))
      .catch(getOriginRejectFn(reject))
  })

  if (conf.onSuccess) {
    promise = promise.then(conf.onSuccess)
  }

  if (onFailure) {
    promise = promise.catch(onFailure)
  }

  return promise
}

export function noticeError (error, message) {
  let content = null

  if (error.message && error.message !== 'No message available') {
    if (Array.isArray(error.message)) {
      content = error.message.join('\n')
    } else {
      content = error.message
    }
  } else if (message && message !== '') {
    content = message
  } else {
    content = ''
  }

  this.$q.notify({
    type: 'negative',
    message: content,
    progress: true,
    timeout: 8000
  })
}
